/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-underscore-dangle */
import { Container, Box, Typography } from '@mui/material';

const AboutUs = () => {
  return (
    <Container sx={{ px: 0, pb: 4 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 6, mb: 2 }}>
        About Us
      </Typography>
      <Box
        sx={{
          px: 3,
          py: 3,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          maxWidth: 1000,
          mx: 'auto',
          color: '#444',
          fontSize: '0.95rem',
          lineHeight: 1.8,
          textAlign: 'left',
        }}
      >
        {/* <Typography fontWeight="bold" gutterBottom>
          Terms and conditions of use
        </Typography> */}
        <Typography paragraph>
          Digital Anarchy is a privately owned company in San Francisco, CA that
          creates smart image enhancement software for video editors, broadcast
          designers and photographers. These tools let you spend less time in
          production and more time on creative work, solving issues from skin
          smoothing software to removing flicker from video. Digital Anarchy
          products work in Adobe After Effects, Final Cut Pro, Premiere Pro,
          Avid, Davinci Resolve, Assimilate Scratch and Photoshop. For more
          information, please see the company&apos;s website at{' '}
          <Box
            component="a"
            href="https://www.digitalanarchy.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'inherit', textDecoration: 'none', fontWeight: 700 }}
          >
            www.digitalanarchy.com
          </Box>{' '}
          or call 415-287-6069.
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutUs;
